export function OutlineLocationpinIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4599 3C5.73154 3 2.83487 10.8464 6.79873 15.3134L8.84165 17.3614L12.4599 21L16.0986 17.3614L17.9839 15.476C22.1358 11.0344 19.2544 3 12.4599 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M12.4547 13.5848C14.2089 13.5848 15.6309 12.1627 15.6309 10.4086C15.6309 8.65444 14.2089 7.23242 12.4547 7.23242C10.7006 7.23242 9.27856 8.65444 9.27856 10.4086C9.27856 12.1627 10.7006 13.5848 12.4547 13.5848Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
